export default "__VITE_ASSET__0d790754__"